import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { motion } from 'framer-motion';
import { BookText } from 'lucide-react';
const chapters = ['Qué son las pomadas naturales', 'Ingredientes básicos y dónde conseguirlos', 'Materiales necesarios', 'Cómo hacer una base universal de pomada', '6 Recetas de pomadas naturales', 'Consejos de almacenamiento', 'Precauciones importantes'];
export function WhatsInside() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <SectionWrapper id="contenido" className="px-4 md:px-12 max-w-4xl mx-auto" data-id="element-240">
      <div className="bg-parchment border-2 border-sage/30 rounded-3xl p-8 md:p-16 shadow-warm relative overflow-hidden" data-id="element-241">
        {/* Decorative corner */}
        <div className="absolute top-0 right-0 w-32 h-32 bg-sage/10 rounded-bl-full" data-id="element-242" />

        <div className="flex items-center justify-center mb-10" data-id="element-243">
          <BookText className="w-8 h-8 text-forest mr-4" data-id="element-244" />
          <h2 className="text-3xl md:text-4xl font-playfair text-forest text-center" data-id="element-245">
            ¿Qué encontrarás en esta guía?
          </h2>
        </div>

        <div className="space-y-6 mb-12" data-id="element-246">
          {chapters.map((chapter, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="flex items-end" data-id="element-247">
              <span className="text-amber font-playfair font-bold text-xl mr-4 w-6 text-right shrink-0" data-id="element-248">
                {idx + 1}.
              </span>
              <span className="text-lg md:text-xl text-brown/90 font-medium min-w-0" data-id="element-249">
                {chapter}
              </span>
              <div className="flex-grow border-b-2 border-dotted border-sage/40 mx-4 mb-2 hidden sm:block" data-id="element-250"></div>
            </motion.div>)}
        </div>

        <div className="text-center" data-id="element-251">
          <button onClick={scrollToPricing} className="inline-block bg-forest text-parchment px-8 py-3 rounded-full font-semibold hover:bg-forest/90 transition-colors shadow-md" data-id="element-252">
            Obtener Acceso Completo
          </button>
        </div>
      </div>
    </SectionWrapper>;
}